import { Component } from 'react';
import CardList from '../components/CardList';
// import { robots } from './robots';
import SearchBox from '../components/SearchBox';
import './App.css';
import Scroll from '../components/Scroll';
import ErrorBoundry from '../components/ErrorBoundry';

class App extends Component {
    constructor(){
        super()
        this.state = {
            robots: [],   // earlier we use robots in place of [] and import robot.js file and not used componetdidmount
            searchfield: '' // state updated when user type something in input box
        }
    }

    componentDidMount(){  // it is part of react so no need to use arrow func^n here state updated or changes so react lifecycle follows mounting -> updating -> unmounting so first constructor triggered thea render than componentdidmount then render because at componentdidmount state is updating so it goes back to render according to react lifecycle
        fetch('https://jsonplaceholder.typicode.com/users')
            .then(res => {
                return res.json();
            })
            .then(users => {
                this.setState({robots: users});
            })
    }

    onSearchChange = (event) => {
        this.setState({ searchfield: event.target.value })   // whenever i want to change or update the state use setState
    }

    render(){
        const {robots, searchfield} = this.state;
        const filteredRobots = robots.filter(robot => {
            return robot.name.toLowerCase().includes(searchfield.toLowerCase())
        })
        if(!robots.length){
            return <h1>Loading</h1>
        }
        else{
            return (
                <div className='tc'>
                    <h1 className='f1'>RoboFriends</h1>
                    <SearchBox searchChange={this.onSearchChange}/>
                    <Scroll>
                        <ErrorBoundry>
                            <CardList robots={filteredRobots}/>
                        </ErrorBoundry>
                    </Scroll>
                </div>
            );
        }
    }
 
}

export default App;


// In props data flows from parents to children but if
// children want to communicate with siblings or with parent 
// what we can do then we introduce the concept called state

// state is an object that discribe our application